import React from "react";
import { createStackNavigator } from "@react-navigation/stack";
import {getTranslation} from "../../helpers/getTranslation";

const SubScreensStack = createStackNavigator();

export default function SubScreensNavigation({navigation, route}) {
  return (
    <SubScreensStack.Navigator>
      <SubScreensStack.Screen
        name={`${route.params.mainSlug}`}
        component={route.params.mainComponent}
        initialParams={{
          screenTitle: route.params.screenTitle,
          headerOptions: route.params.headerOptions,
          showCopyright: route.params.showCopyright,
        }}
        options={{headerShown: false}}
      />
      {route.params.subScreens.map((subScreen, idx) => (
        <SubScreensStack.Screen
          key={`SubScreen_${idx}`}
          name={subScreen.navSlug}
          component={subScreen.component}
          initialParams={{
            screenTitle: subScreen.screenTitle,
            headerOptions: {...subScreen.headerOptions, menuArea:'back'},
            showCopyright: subScreen.showCopyright,
          }}
          options={{
            headerShown: false,
            title: getTranslation(subScreen.navTitle)
          }}
        />
      ))}
    </SubScreensStack.Navigator>
  )
}
